import { render } from "./HzbaTextareaInput.vue?vue&type=template&id=649d1bd8&scoped=true"
import script from "./HzbaTextareaInput.vue?vue&type=script&lang=js"
export * from "./HzbaTextareaInput.vue?vue&type=script&lang=js"

import "./HzbaTextareaInput.vue?vue&type=style&index=0&id=649d1bd8&scoped=true&lang=scss"
import "./HzbaTextareaInput.vue?vue&type=style&index=1&id=649d1bd8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649d1bd8"]])

export default __exports__